import { render, staticRenderFns } from "./SettingsBooking.vue?vue&type=template&id=1ba09fb6&scoped=true"
import script from "./SettingsBooking.vue?vue&type=script&lang=js"
export * from "./SettingsBooking.vue?vue&type=script&lang=js"
import style0 from "./SettingsBooking.vue?vue&type=style&index=0&id=1ba09fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba09fb6",
  null
  
)

export default component.exports